"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _localeData = _interopRequireDefault(require("dayjs/plugin/localeData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * This utility class provides localization for `react-day-picker`
 * through `dayjs`.
 * See: https://react-day-picker.js.org/api/LocaleUtils/
 */
_dayjs["default"].extend(_localeData["default"]);

var formatDate = function formatDate(date, format, locale) {
  if (format === void 0) {
    format = 'L';
  }

  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])(date).locale(locale).format(format);
};

var formatDay = function formatDay(day, locale) {
  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])(day).locale(locale).format('ddd ll');
};

var formatMonthTitle = function formatMonthTitle(month, locale) {
  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])(month).locale(locale).format('MMMM YYYY');
};

var formatWeekdayShort = function formatWeekdayShort(weekday, locale) {
  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])().locale(locale).localeData().weekdaysMin()[weekday];
};

var formatWeekdayLong = function formatWeekdayLong(weekday, locale) {
  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])().locale(locale).localeData().weekdays()[weekday];
};

var getFirstDayOfWeek = function getFirstDayOfWeek(locale) {
  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])().locale(locale).localeData().firstDayOfWeek();
};

var getMonths = function getMonths(locale) {
  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])().locale(locale).localeData().months();
};

var parseDate = function parseDate(str, format, locale) {
  if (format === void 0) {
    format = 'L';
  }

  if (locale === void 0) {
    locale = 'en';
  }

  return (0, _dayjs["default"])(str, {
    format: format,
    locale: locale
  }, true).toDate();
};

var _default = {
  formatDate: formatDate,
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayLong: formatWeekdayLong,
  formatWeekdayShort: formatWeekdayShort,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths,
  parseDate: parseDate
};
exports["default"] = _default;